<template>
  <FlexColumn>
    <TextButton
        secondary
        :small="small"
        :right-icon="saved ? 'mdi-check' : undefined"
        @click="handleSave"
    >
      検索条件を更新
    </TextButton>
  </FlexColumn>
</template>

<script>
import TextButton from "../atoms/TextButton";
import {mapGetters} from "vuex";
import ApiMixin from "../../ApiMixin";
import FlexColumn from "../atoms/FlexColumn";
export default {
  name: "ApplicantSearchConditionSetUpdateButton",
  mixins: [ApiMixin],
  components: {FlexColumn, TextButton},
  props: {
    andKeyword: {
      type: String
    },
    orKeyword: {
      type: String
    },
    data: {
      type: Array
    },
    dataType: {
      type: String
    },
    currentPrefectures: {
      type: Array,
    },
    prefectures: {
      type: Array,
    },
    positions: {
      type: Array
    },
    salary: {
      type: Object,
      default: () => ({})
    },
    gender: {
      type: Number
    },
    age: {
      type: Object,
      default: () => ({})
    },
    medalist: {
      type: Boolean
    },
    newcomer: {
      type: Boolean
    },
    scoutable: {
      type: Boolean
    },
    small: {
      type: Boolean
    }
  },
  data() {
    return {
      saved: false
    }
  },
  computed: {
    ...mapGetters("client", ["company"]),
    ...mapGetters("chatRequests", ["selectedSearchConditionSet"]),
    id() {
      return this.selectedSearchConditionSet.id
    },
    name() {
      return this.selectedSearchConditionSet.name
    }
  },
  methods: {
    handleClose() {
      this.open = false
    },
    handleSave() {
      if (this.id) {
        this.updateChatRequestSearchConditions(this.company.id, this.id, this.name, {
          andKeyword: this.andKeyword,
          orKeyword: this.orKeyword,
          data: this.data,
          dataType: this.dataType,
          currentLocation: this.currentPrefectures,
          location: this.prefectures,
          currentJob: this.positions,
          salaryLower: this.salary.lower,
          salaryUpper: this.salary.upper,
          gender: this.gender,
          ageLower: this.age.lower,
          ageUpper: this.age.upper,
          medalist: this.medalist,
          newcomer: this.newcomer,
          scoutable: this.scoutable,
        })
        this.saved = true
        setTimeout(() => {
          this.saved = false
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>

</style>
